<template>
    <v-content class="main-wrap">
        <router-view />

        <dashboard-core-footer />
    </v-content>
</template>

<style lang="scss">
    .main-wrap {
        .v-content__wrap {
            padding-bottom: 100px;
        }
    }
</style>

<script>
    export default {
        name: "DashboardCoreView",

        components: {
            DashboardCoreFooter: () => import("./footer"),
        },
    };
</script>
